import { Component } from "@angular/core";
import { AuthService } from "@app/auth/services/auth.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-login",
  templateUrl: "./password_reset.component.html",
  styleUrls: ["./password_reset.component.scss"],
})
export class PasswordResetComponent {
  error: string | undefined;
  resetSuccess = false;
  signupForm: FormGroup;
  moreInfo: boolean = true;
  emailSent: boolean = false;
  signupAttempts = 0;

  constructor(
      private authService: AuthService,
      private formBuilder: FormBuilder,
  ) {}

  ngOnInit() {
    this.createForm();
  }

  createForm(): void {
    const email = "";
    this.signupForm = this.formBuilder.group({
      email: [email, [Validators.required, Validators.maxLength(100), Validators.email]]
    });
  }

  get email() {
    return this.signupForm.get("email");
  }

  changeEmail() {
    this.resetSuccess = false;
    this.moreInfo = true;
    this.emailSent = false;
  }

  resendEmail() {
    this.emailSent = true;
    this.onSubmit();
  }

  onSubmit() {
    this.error = "";
    if (this.signupForm.valid) {
      this.authService
          .sendPasswordResetToken({ email: this.email.value })
          .subscribe((response) => {
            if (response.ok) {
              this.resetSuccess = true;
              this.signupAttempts= 0;
            } else {
              this.error = response.error?.error || "An unexpected error has occurred.";
            }
          }, () => {
            this.error = "An unexpected error has occurred."
          });
    }
  }
}
